import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import { createSelector } from "reselect";
import type { ExportName } from "../type";
import { selectManagementReducer } from "./managementSelectors";

const selectCommonReducer = createStatePropertySelector(selectManagementReducer("common"));

const selectInvalidPreDefined = selectCommonReducer("invalidPredefined");
export const selectCurrentExportTab = selectCommonReducer("currentExportTab");
export const selectPreviousExportTab = selectCommonReducer("previousExportTab");
export const selectCacheToken = selectCommonReducer("cacheToken");
export const selectRecordToEnableExport = selectCommonReducer("recordToEnableExport");

export const selectAllInvalidPreDefinedFields = createSelector(selectInvalidPreDefined, (allInvalidByTab) => {
    return Object.values(allInvalidByTab).flat();
});

export const selectCurrentInvalidPreDefined = (tabName: ExportName) =>
    createSelector(selectInvalidPreDefined, (allInvalid) => {
        return allInvalid[tabName];
    });

export const selectTabsWithValidationError = createSelector(selectInvalidPreDefined, (allInvalid): ExportName[] => {
    const tabNames = Object.keys(allInvalid);

    return tabNames.filter((name) => allInvalid[name].length) as ExportName[];
});
